import { Page } from '@/core/architecture'

import { MyTradeDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * MyTradeDetail Page
 * Implemented as a practical sample.
 */
export const MyTradeDetail: Page = () => {
  const { state, actions } = useViewModel()

  return <MyTradeDetailTemplate state={state} {...actions} />
}
